import { i18n } from 'i18next';

export type I18nInstance = i18n;
export * from './namescape';
export * from './lng';
export * from './i18n.d';
